export default __webpack_public_path__ + "assets/search-component.1d6aaff6.svg";